module.exports = __webpack_public_path__ + "img/magazine.ba8cef96.jpg";